import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import _FM_ReservationGuestFormComponent from "./_FM_ReservationGuestFormComponent";
import _FM_ReservationCustomerFolioListComponent from "../../components/_FM_folio/_FM_FolioListComponent";
import {Badge} from "primereact/badge";
import {Message} from "primereact/message";
import {closeMercureSubscription, openMercureSubscription} from "../../util/mercure";

const _FM_ReservationGuestListComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [reservation, setReservation] = useState(props.reservation || {});
  const [guests, setGuests] = useState(props.reservation?.guests || []);
  const [loading, setLoading] = useState(false);
  const initialLoadRef = useRef(true);

  useEffect(() => {
    if (props.reservation && props.reservation.id) {
      setReservation(props.reservation);
      setGuests(props.reservation.guests || []);
    }
  }, [props.reservation]);

  useEffect(() => {
    if (reservation.unique_id && reservation.password && reservation.unique_id !== '' && reservation.password !== '' && reservation.unique_id !== null && reservation.password !== null) {
      const topic = process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST.replace('/api', '')
        + Cookies.get("instanceId") + "/api/public/reservation/" + reservation.unique_id
        + "/" + reservation.password;
      const eventSource = openMercureSubscription({
        topics: [topic],
      });
      if (!eventSource) {
        return undefined;
      }
      console.log('feliratkozás történt: ' + topic)
      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log('push notification arrived:');
        console.log(data)
        window.App.setState({rerenderReservationGuestList: Math.random()})
      }
      return () => {
        closeMercureSubscription(eventSource);
        console.log('leiratkozás történt: ' + topic)
      };
    }
  }, [reservation]);

  useEffect(() => {
    const hasReservationProp = !!props.reservation?.id;
    const shouldSkipInitialApiLoad = initialLoadRef.current && hasReservationProp;

    if (shouldSkipInitialApiLoad) {
      initialLoadRef.current = false;
      return;
    }

    initialLoadRef.current = false;

    if (id) {
      axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "reservation/"
        + id,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setGuests(response.data.data.guests)
          setReservation(response.data.data)
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        })
    }
  }, [id, props.reservation?.id, window.App.state.rerenderReservationGuestList])

  const formatGuestDate = (dateValue) => {
    if (!dateValue) {
      return '-';
    }

    return moment.utc(dateValue).local().format(t('YYYY-MM-DD'));
  };

  const activeGuests = (guests || []).filter((guest) => guest.deleted_at_snapshot === null);

  return (
    <>

      <div className={"guests"}>
        {reservation.additional_answers && reservation.additional_answers[0] &&
          <>
            <div className={"guest p-p-3 p-my-3"}>
              <div className={"p-grid"}>
                <div className={"p-col p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('other')}</h2>
                </div>
              </div>
              <div className={"p-grid"}>
                {Object.values(reservation.additional_answers).map((item, index) => (
                  <div className="p-col" key={index}>
                    <small className="p-text-uppercase">{item.label}</small>
                    <p className="p-mt-0 p-mb-0 p-text-bold">
                      {item.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </>
        }
      </div>
      <div className={"p-grid"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('guest_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {action === 'update' &&
            <Button
              type="button"
              disabled={reservation.status === 'checked_out' || reservation.status === 'cancelled' || reservation.status === 'not_shown'}
              label={t('new_guest')}
              icon={"pi pi-plus"}
              loading={loading}
              onClick={() => {
                if (window.location.href.includes('#/reservation')) {
                  navigate('/reservation/' + action + '/' + id + '?create=guest')
                }
                if (window.location.href.includes('#/calendar')) {
                  navigate('/calendar/' + action + '/' + id + '?create=guest')
                }
              }}
              className="p-button-success p-ml-2"
            />
          }
        </div>
      </div>
      <div className={"guests"}>
        {activeGuests[0] ? (
          <>
            {activeGuests.map((guest, index) => {
              let guestCountyCode = guest?.accommodation?.country?.toLowerCase();
              if (guest.deleted_at_snapshot === null) {
                return (
                  <div
                    className={index === 0 ? "guest p-p-3" : "guest p-p-3 p-mt-3"}
                    key={index}
                  >
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-3 p-col-align-center"}>
                        <h3 className={"p-my-0"}>{t('guest') + ' ' + (index + 1)}</h3>
                      </div>
                      <div className={"p-col-12 p-lg-9 p-col-align-center p-text-right"}>
                        {action === 'read' &&
                          <>
                            {guest.status.toLowerCase() === 'pending' ? (
                              <Badge value={t('pending')} severity="info"
                                     className={"p-ml-2"}
                                     style={{
                                       backgroundColor: '#dddddd',
                                       color: '#5f656b',
                                     }}></Badge>
                            ) : guest.status.toLowerCase() === 'confirmed' ? (
                              <Badge value={t('confirmed')} severity="success"
                                     className={"p-ml-2"}
                                     style={{
                                       backgroundColor: '#f1eea5',
                                       color: '#5f656b',
                                     }}></Badge>
                            ) : guest.status.toLowerCase() === 'will_arrive' ? (
                              <Badge value={t('will_arrive')} severity="info"
                                     className={"p-ml-2"}
                                     style={{
                                       backgroundColor: '#dddddd',
                                       color: '#5f656b',
                                     }}></Badge>
                            ) : guest.status.toLowerCase() === 'cancelled' ? (
                              <Badge value={t('cancelled')} severity="danger"
                                     className={"p-ml-2"}
                                     style={{backgroundColor: '#f7a2a2'}}></Badge>
                            ) : guest.status.toLowerCase() === 'checked_in' ? (
                              <Badge value={t('checked_in')} severity="success"
                                     className={"p-ml-2"}
                                     style={{backgroundColor: '#3ec0e9'}}></Badge>
                            ) : guest.status.toLowerCase() === 'checked_out' ? (
                              <Badge value={t('checked_out')} severity="success"
                                     className={"p-ml-2"}
                                     style={{backgroundColor: '#0abb87'}}></Badge>
                            ) : guest.status.toLowerCase() === 'no_show' ? (
                              <Badge value={t('no_show')} severity="warning"
                                     className={"p-ml-2"}
                                     style={{
                                       backgroundColor: '#8a2be2',
                                       color: '#fff',
                                     }}></Badge>
                            ) : (
                              <Badge value={t('unknown_status')} severity="warning"
                                     className={"p-ml-2"}
                                     style={{backgroundColor: '#ccc'}}></Badge>
                            )}
                          </>
                        }
                        {action === 'update' &&
                          <>
                            {(() => {
                              if (guest.status === 'will_arrive') {
                                return (
                                  <>
                                    <Button
                                      type="button"
                                      label={t('check_in')}
                                      icon={"pi pi-sign-in"}
                                      loading={loading}
                                      onClick={() => {
                                        window.App.setState({[`confirmStatusCheckIn${guest.id}`]: true})
                                      }}
                                      className="p-button-success p-button-sm p-ml-2"
                                    />
                                    <ConfirmDialog group="declarative"
                                                   visible={window.App.state[`confirmStatusCheckIn${guest.id}`]}
                                                   acceptLabel={t('yes')} rejectLabel={t('no')}
                                                   onHide={() => {
                                                     window.App.setState({[`confirmStatusCheckIn${guest.id}`]: false})
                                                   }}
                                                   message={t('confirm_event_patch_message')}
                                                   header={t('check_in')}
                                                   icon="pi pi-exclamation-triangle"
                                                   accept={() => {
                                                     window.App.setState({[`confirmStatusCheckIn${guest.id}`]: false})
                                                     setLoading(true)
                                                     axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guest.id,
                                                       {
                                                         status: "checked_in",
                                                       },
                                                       {
                                                         params: {},
                                                         headers: {
                                                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                           "Sys-name": Cookies.get("instanceId"),
                                                           "Preferred-locale": Cookies.get("language")
                                                         }
                                                       })
                                                       .then(response => {
                                                         setLoading(false)
                                                         window.App.setState({rerenderReservationGuestList: Math.random()})
                                                         window.App.toastShow('success', t('success'), response.data.message)
                                                       })
                                                       .catch(error => {
                                                         setLoading(false)
                                                         window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                       })
                                                   }}
                                                   reject={() => {
                                                     window.App.setState({[`confirmStatusCheckIn${guest.id}`]: false})
                                                   }}/>
                                  </>
                                );
                              } else if (guest.status === 'checked_in') {
                                return (
                                  <>
                                    <Button
                                      type="button"
                                      label={t('check_in_cancel')}
                                      icon={"pi pi-ban"}
                                      loading={loading}
                                      onClick={() => {
                                        window.App.setState({[`confirmStatusCheckInCancel${guest.id}`]: true})
                                      }}
                                      className="p-button-info p-button-sm p-ml-2"
                                    />
                                    <ConfirmDialog group="declarative"
                                                   visible={window.App.state[`confirmStatusCheckInCancel${guest.id}`]}
                                                   acceptLabel={t('yes')} rejectLabel={t('no')}
                                                   onHide={() => {
                                                     window.App.setState({[`confirmStatusCheckInCancel${guest.id}`]: false})
                                                   }}
                                                   message={t('confirm_event_patch_message')}
                                                   header={t('check_in_cancel')}
                                                   icon="pi pi-exclamation-triangle"
                                                   accept={() => {
                                                     window.App.setState({[`confirmStatusCheckInCancel${guest.id}`]: false})
                                                     setLoading(true)
                                                     axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guest.id,
                                                       {
                                                         status: "will_arrive",
                                                       },
                                                       {
                                                         params: {},
                                                         headers: {
                                                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                           "Sys-name": Cookies.get("instanceId"),
                                                           "Preferred-locale": Cookies.get("language")
                                                         }
                                                       })
                                                       .then(response => {
                                                         setLoading(false)
                                                         window.App.setState({rerenderReservationGuestList: Math.random()})
                                                         window.App.toastShow('success', t('success'), response.data.message)
                                                       })
                                                       .catch(error => {
                                                         setLoading(false)
                                                         window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                       })
                                                   }}
                                                   reject={() => {
                                                     window.App.setState({[`confirmStatusCheckInCancel${guest.id}`]: false})
                                                   }}/>
                                    <Button
                                      type="button"
                                      label={t('check_out')}
                                      icon={"pi pi-sign-out"}
                                      loading={loading}
                                      onClick={() => {
                                        window.App.setState({[`confirmStatusCheckOut${guest.id}`]: true})
                                      }}
                                      className="p-button-warning p-button-sm p-ml-2"
                                    />
                                    <ConfirmDialog group="declarative"
                                                   visible={window.App.state[`confirmStatusCheckOut${guest.id}`]}
                                                   acceptLabel={t('yes')} rejectLabel={t('no')}
                                                   onHide={() => {
                                                     window.App.setState({[`confirmStatusCheckOut${guest.id}`]: false})
                                                   }}
                                                   message={t('confirm_event_patch_message')}
                                                   header={t('check_out')}
                                                   icon="pi pi-exclamation-triangle"
                                                   accept={() => {
                                                     window.App.setState({[`confirmStatusCheckOut${guest.id}`]: false})
                                                     setLoading(true)
                                                     axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guest.id,
                                                       {
                                                         status: "checked_out",
                                                       },
                                                       {
                                                         params: {},
                                                         headers: {
                                                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                           "Sys-name": Cookies.get("instanceId"),
                                                           "Preferred-locale": Cookies.get("language")
                                                         }
                                                       })
                                                       .then(response => {
                                                         setLoading(false)
                                                         window.App.setState({rerenderReservationGuestList: Math.random()})
                                                         window.App.toastShow('success', t('success'), response.data.message)
                                                       })
                                                       .catch(error => {
                                                         setLoading(false)
                                                         window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                       })
                                                   }}
                                                   reject={() => {
                                                     window.App.setState({[`confirmStatusCheckOut${guest.id}`]: false})
                                                   }}/>
                                  </>
                                );
                              } else if (guest.status === 'checked_out') {
                                return (
                                  <>
                                    <Button
                                      type="button"
                                      label={t('check_out_cancel')}
                                      icon={"pi pi-sign-out"}
                                      loading={loading}
                                      onClick={() => {
                                        window.App.setState({[`confirmStatusCheckOutCancel${guest.id}`]: true})
                                      }}
                                      className="p-button-warning p-button-sm p-ml-2"
                                    />
                                    <ConfirmDialog group="declarative"
                                                   visible={window.App.state[`confirmStatusCheckOutCancel${guest.id}`]}
                                                   acceptLabel={t('yes')} rejectLabel={t('no')}
                                                   onHide={() => {
                                                     window.App.setState({[`confirmStatusCheckOutCancel${guest.id}`]: false})
                                                   }}
                                                   message={t('confirm_event_patch_message')}
                                                   header={t('check_out_cancel')}
                                                   icon="pi pi-exclamation-triangle"
                                                   accept={() => {
                                                     window.App.setState({[`confirmStatusCheckOutCancel${guest.id}`]: false})
                                                     setLoading(true)
                                                     axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guest.id,
                                                       {
                                                         status: "checked_in",
                                                       },
                                                       {
                                                         params: {},
                                                         headers: {
                                                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                           "Sys-name": Cookies.get("instanceId"),
                                                           "Preferred-locale": Cookies.get("language")
                                                         }
                                                       })
                                                       .then(response => {
                                                         setLoading(false)
                                                         window.App.setState({rerenderReservationGuestList: Math.random()})
                                                         window.App.toastShow('success', t('success'), response.data.message)
                                                       })
                                                       .catch(error => {
                                                         setLoading(false)
                                                         window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                       })
                                                   }}
                                                   reject={() => {
                                                     window.App.setState({[`confirmStatusCheckOutCancel${guest.id}`]: false})
                                                   }}/>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <Button
                                      type="button"
                                      label={t('check_in')}
                                      icon={"pi pi-sign-in"}
                                      loading={loading}
                                      onClick={() => {
                                        window.App.setState({[`confirmStatusCheckIn${guest.id}`]: true})
                                      }}
                                      className="p-button-success p-button-sm p-ml-2"
                                    />
                                    <ConfirmDialog group="declarative"
                                                   visible={window.App.state[`confirmStatusCheckIn${guest.id}`]}
                                                   acceptLabel={t('yes')} rejectLabel={t('no')}
                                                   onHide={() => {
                                                     window.App.setState({[`confirmStatusCheckIn${guest.id}`]: false})
                                                   }}
                                                   message={t('confirm_event_patch_message')}
                                                   header={t('check_in')}
                                                   icon="pi pi-exclamation-triangle"
                                                   accept={() => {
                                                     window.App.setState({[`confirmStatusCheckIn${guest.id}`]: false})
                                                     setLoading(true)
                                                     axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guest.id,
                                                       {
                                                         status: "checked_in",
                                                       },
                                                       {
                                                         params: {},
                                                         headers: {
                                                           'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                           "Sys-name": Cookies.get("instanceId"),
                                                           "Preferred-locale": Cookies.get("language")
                                                         }
                                                       })
                                                       .then(response => {
                                                         setLoading(false)
                                                         window.App.setState({rerenderReservationGuestList: Math.random()})
                                                         window.App.toastShow('success', t('success'), response.data.message)
                                                       })
                                                       .catch(error => {
                                                         setLoading(false)
                                                         window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                       })
                                                   }}
                                                   reject={() => {
                                                     window.App.setState({[`confirmStatusCheckIn${guest.id}`]: false})
                                                   }}/>
                                  </>
                                );
                              }
                            })()}
                          </>
                        }
                      </div>
                    </div>
                    <hr/>
                    <div className="p-grid p-mt-1">
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("lastname")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.lastname}</p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("firstname")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.firstname}</p>
                      </div>
                      {guest.status === 'will_arrive' &&
                        <>
                          <div className="p-col-12 p-lg-3">
                            <small className="p-text-uppercase">
                              {t('expected_arrival')}
                            </small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {guest.expected_check_in_at ? (
                                <>
                                  {moment.utc(guest.expected_check_in_at).local().format(t('YYYY-MM-DD'))}
                                </>
                              ) : (
                                <>
                                  {moment.utc(reservation.reserved_from).local().format(t('YYYY-MM-DD'))} ({t('not_set')})
                                </>
                              )}
                            </p>
                          </div>
                          <div className="p-col-12 p-lg-3">
                            <small className="p-text-uppercase">
                              {t('expected_departure')}
                            </small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {moment.utc(reservation.reserved_to).local().format(t('YYYY-MM-DD'))}
                            </p>
                          </div>
                        </>
                      }
                      {guest.status === 'checked_in' &&
                        <>
                          <div className="p-col-12 p-lg-3">
                            <small className="p-text-uppercase">
                              {t('checked_in')}
                            </small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {moment.utc(guest.checked_in_at).local().format(t('YYYY-MM-DD'))}
                            </p>
                          </div>
                          <div className="p-col-12 p-lg-3">
                            <small className="p-text-uppercase">
                              {t('expected_departure')}
                            </small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {moment.utc(reservation.reserved_to).local().format(t('YYYY-MM-DD'))}
                            </p>
                          </div>
                        </>
                      }
                      {guest.status === 'checked_out' &&
                        <>
                          <div className="p-col-12 p-lg-3">
                            <small className="p-text-uppercase">
                              {t('checked_in')}
                            </small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {moment.utc(guest.checked_in_at).local().format(t('YYYY-MM-DD'))}
                            </p>
                          </div>
                          <div className="p-col-12 p-lg-3">
                            <small className="p-text-uppercase">
                              {t('checked_out')}
                            </small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {moment.utc(guest.checked_out_at).local().format(t('YYYY-MM-DD'))}
                            </p>
                          </div>
                        </>
                      }
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">

                        </small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">

                        </p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("gender")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{t(guest?.gender?.toLowerCase())}</p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("citizenship")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.citizenship}</p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("residence_country")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.residence_country}</p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("birth_date")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">
                          {guest.birth_date &&
                            <>
                              {moment.utc(guest.birth_date).local().format(t('YYYY-MM-DD'))}
                            </>
                          }
                        </p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("birth_place")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.birth_place}</p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("id_type")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{t(guest?.id_type?.toLowerCase())}</p>
                      </div>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("id_number")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.id_number}</p>
                      </div>
                    </div>
                    <div className={"p-grid p-mt-1"}>
                      <div className="p-col-12 p-lg-3">
                        <small className="p-text-uppercase">{t("zip_code")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.zip_code}</p>
                      </div>
                      <div className="p-col-12 p-lg-9">
                        <small className="p-text-uppercase">{t("address")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.address}</p>
                      </div>
                    </div>
                    <div className={"p-grid p-mt-1"}>
                      <div className="p-col-12 p-lg-4">
                        <small className="p-text-uppercase">{t("company_name")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.company_name}</p>
                      </div>
                      <div className="p-col-12 p-lg-4">
                        <small className="p-text-uppercase">{t("email")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.email}</p>
                      </div>
                      <div className="p-col-12 p-lg-4">
                        <small className="p-text-uppercase">{t("phone")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.phone}</p>
                      </div>
                      <div className="p-col-12 p-lg-12">
                        <small className="p-text-uppercase">{t("note")}</small>
                        <p className="p-mt-0 p-mb-0 p-text-bold">{guest.note}</p>
                      </div>
                    </div>
                    {guest.guest_hus && guest.guest_hus[0] &&
                      <div className={"p-grid p-mt-1"}>
                        {guest.guest_hus.map((item, index) => {
                          return (
                            <>
                              {Object.entries(item)
                                .filter(([key]) => key !== 'id' && !key.startsWith('_'))
                                .map(([key, value]) => (
                                  <div className={"p-col"} key={key}>
                                    <small className="p-text-uppercase">{t(key)}</small>
                                    <p
                                      className="p-mt-0 p-mb-0 p-text-bold">{typeof value === 'object' ? JSON.stringify(value) : String(t(value?.toLowerCase()))}</p>
                                  </div>
                                ))}
                            </>
                          )
                        })}
                      </div>
                    }
                    {guest && guest.additional_answers &&
                      <div className={"p-grid p-mt-1"}>
                        {Object.values(guest.additional_answers).map((item, index) => (
                          <div className="p-col" key={index}>
                            <small className="p-text-uppercase">{item.label}</small>
                            <p className="p-mt-0 p-mb-0 p-text-bold">
                              {item.value}
                            </p>
                          </div>
                        ))}
                      </div>
                    }
                    {action === 'update' &&
                      <>
                        <hr/>
                        <div className={"p-grid p-mt-1"}>
                          <div className={"p-col-12 p-lg-3 p-col-align-center"}>

                          </div>
                          <div className={"p-col-12 p-lg-9 p-text-right p-col-align-center"}>
                            <Button
                              type="button"
                              label={t('edit_guest')}
                              icon={"pi pi-pencil"}
                              loading={loading}
                              onClick={() => {
                                if (window.location.href.includes('#/reservation')) {
                                  navigate('/reservation/' + action + '/' + id + '?update=guest&guestId=' + guest.id)
                                }
                                if (window.location.href.includes('#/calendar')) {
                                  navigate('/calendar/' + action + '/' + id + '?update=guest&guestId=' + guest.id)
                                }
                              }}
                              className="p-button-warning  p-button-sm p-ml-2"
                            />
                            {guest.status !== 'checked_in' &&
                              <>
                                <Button
                                  type="button"
                                  label={t('delete_guest')}
                                  icon={"pi pi-trash"}
                                  loading={loading}
                                  onClick={() => {
                                    window.App.setState({[`confirmDelete${guest.id}`]: true})
                                  }}
                                  className="p-button-danger  p-button-sm p-ml-2"
                                />
                                <ConfirmDialog group="declarative"
                                               visible={window.App.state[`confirmDelete${guest.id}`]}
                                               acceptLabel={t('yes')} rejectLabel={t('no')}
                                               onHide={() => {
                                                 window.App.setState({[`confirmDelete${guest.id}`]: false})
                                               }}
                                               message={t('confirm_delete')} header={t('confirm_delete')}
                                               icon="pi pi-exclamation-triangle"
                                               accept={() => {
                                                 axios.delete(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "guest/" + guest.id,
                                                   {
                                                     params: {},
                                                     headers: {
                                                       'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                       "Sys-name": Cookies.get("instanceId"),
                                                       "Preferred-locale": Cookies.get("language")
                                                     }
                                                   })
                                                   .then(response => {
                                                     setLoading(false)
                                                     window.App.setState({rerenderReservationGuestList: Math.random()})
                                                     window.App.toastShow('success', t('success'), response.data.message)
                                                   })
                                                   .catch(error => {
                                                     setLoading(false)
                                                     window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                                   })
                                               }}
                                               reject={() => {
                                                 window.App.setState({[`confirmDelete${guest.id}`]: false})
                                               }}/>
                              </>
                            }
                          </div>
                        </div>
                      </>
                    }
                  </div>
                )
              }
            })}
          </>
        ) : (
          <p className={"p-m-0 p-p-0"}>
            {t('no_guests_yet')}
          </p>
        )
        }
      </div>
      <Dialog header={t('guest')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                               text={t("dialog_movable")}/></React.Fragment>}
              visible={window.App.urlVars().create === 'guest' || window.App.urlVars().update === 'guest'}
              onHide={() => {
                navigate(-1)
              }} style={{minWidth: '780px', width: '780px', maxWidth: '780px'}} modal={false}>
        {reservation && Object.keys(reservation).length > 0 ? (
          <_FM_ReservationGuestFormComponent uniqueId={reservation.unique_id} password={reservation.password}
                                             reservation={reservation}/>
        ) : (
          <div className="p-p-3 p-text-center">
            {t('loading')}
          </div>
        )}
      </Dialog>
      <Dialog header={t('customer_folio')} visible={window.App.urlVars().read === 'customerFolio'}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}}
                                               severity="info" text={t("dialog_movable")}/></React.Fragment>}
              onHide={() => {
                navigate(-1)
              }} style={{minWidth: '780px', width: '780px', maxWidth: '780px'}} modal={false}>
        <_FM_ReservationCustomerFolioListComponent customerId={window.App.urlVars().customerId}/>
      </Dialog>
    </>
  )
}
export default withTranslation('common')(_FM_ReservationGuestListComponent);
